import React from "react"
import { Link as GatsbyLink } from "gatsby";
import PropTypes from 'prop-types';


const Link = ({ children, to, prefetch=true,...props }) => {
    if(prefetch) {
        return <GatsbyLink to={to} {...props}>{children}</GatsbyLink>
    }    
    return <a href={to} {...props} data-prefetch="false">{children}</a>
}

Link.propTypes = {
    children: PropTypes.node.isRequired,
    to: PropTypes.string.isRequired,
    prefetch: PropTypes.bool,
};

export default Link;

